import gtmPusher from '../utils/gtmPusher';

const handleTracking = (data, productData) => {
  window.ua('trackPageView', null, [
    {
      schema: 'iglu:it.uniid/page/jsonschema/1-0-0',
      data: {
        pageType: 'product'
      }
    },
    {
      schema: 'iglu:it.uniid/product/jsonschema/1-0-6',
      data: productData
    }
  ]);

  // GOOGLE ANALYTICS
  const ecommerceObj = {
    event: 'productDetailView',
    eventCategory: 'ecommerce',
    eventAction: 'product detail view',
    eventLabel: 'product',
    eventValue: 0,
    eventNonInteraction: true,
    currencyCode: data.currency,
    list: 'product page'
  };
  const product = {
    ...data,
    product_id: data.product_id,
    product: data.title,
    unit_net: data.prices.min_price,
    variant: '',
    position: 1
  };
  gtmPusher(ecommerceObj, [product]);
  // -- END GOOGLE ANALYTICS --
};

export default handleTracking;
